<template>
  <div class="list">
    <v-container class="my-7" v-if="!loading">
      <banner type="top" class="mb-7" />

      <Title no-decoration>
        {{ vinheta }}
      </Title>

      <div class="article-grid" v-if="totalItems">
        <div class="article-item">
          <article-card
            v-for="({ id, title, img, category }, index) in articles"
            :key="index"
            :id="id"
            :title="title"
            :img="img"
            :categoryTitle="category ? category.title : ''"
          ></article-card>
        </div>

        <v-pagination
          v-model="page"
          :length="pagesLength"
          :total-visible="9"
          v-if="pagesLength > 1"
        ></v-pagination>
      </div>
      <v-alert v-else name="warn" type="warning" class="mt-6">
        Nenhum conteúdo adicionado até o momento.
      </v-alert>

      <banner type="center-2" class="mt-7" />
    </v-container>
    <v-sheet
      v-else
      class="d-flex justify-center align-center my-16"
      height="100%"
      width="100%"
      color="transparent"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-sheet>
  </div>
</template>

<script>
import Banner from "@/components/cards/Banner.vue";
import Title from "@/components/widgets/Title.vue";
import ArticleCard from "@/components/cards/Article.vue";
import { formatToURL } from "@/components/utils";

export default {
  data: () => ({
    loading: true,
    articles: [],
    itemsPerPage: 24,
    totalItems: 0,
  }),
  computed: {
    page: {
      get() {
        const p = this.$route.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.$route.query };
        query.p = v;

        return this.$router.push({ query });
      },
    },
    pagesLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    categories() {
      return this.$rest("articles-categories").list.map(({ id, title }) => ({
        id,
        title: title,
        uri: formatToURL(title),
      }));
    },
    vinheta() {
      if (!this.$route.params.category) return this.title;

      return !this.filterCategory
        ? this.title
        : `${this.title} / ${this.filterCategory.title}`;
    },
    filterCategory() {
      if (!this.$route.params.category) return "";

      return this.categories.filter(
        (category) => category.uri === this.$route.params.category
      )[0];
    },
    type() {
      return this.$route.meta.type || "articles";
    },
    title() {
      return this.$route.meta.title || "Notícias";
    },
    q() {
      return this.$route.query.q;
    },
  },
  created() {
    this.get();
  },
  watch: {
    filterCategory() {
      this.get();
    },
    page() {
      this.get();
    },
    q() {
      this.get();
    },
  },
  methods: {
    get() {
      const params = {
        itemsPerPage: this.itemsPerPage,
        returnTotalItems: 1,
        type: this.type,
      };

      if (this.filterCategory) params.category = this.filterCategory.id;
      if (this.page) params.page = this.page;
      if (this.$route.query.q) params.search = this.$route.query.q;

      this.loading = true;

      this.$rest("articles")
        .get({
          params,
          keepCache: true,
          save: (state, { totalItems, list }) => {
            this.articles = list;
            this.totalItems = totalItems;

            if (!list.length && this.page > 1) this.page = 1;
          },
        })
        .then(() => (this.loading = false));
    },
  },
  components: {
    Banner,
    ArticleCard,
    Title,
  },
};
</script>

<style scoped>
.article-grid {
  display: grid;
  gap: 30px;
  margin-top: 30px;
}

.article-item {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 40px 16px;
}

@media screen and (max-width: 960px) {
  .article-item {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

@media screen and (max-width: 600px) {
  .article-item {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
